"use client";

import { useState } from "react";

interface PhaseDetail {
  id: string;
  nameEn: string;
  nameHi: string;
  duration: string;
  transitHouse: string;
  colorClass: string;
  badgeClass: string;
  descriptionEn: string;
  descriptionHi: string;
  keyChallengeEn: string;
  keyChallengeHi: string;
  upayEn: string;
  upayHi: string;
}

const PHASES: PhaseDetail[] = [
  {
    id: "phase1",
    nameEn: "Phase 1: Rising (Aarohan)",
    nameHi: "प्रथम चरण: आरोही (12वां भाव)",
    duration: "~2.5 Years",
    transitHouse: "12th House from Natal Moon",
    colorClass: "border-warning/30 bg-warning/10 text-text-primary",
    badgeClass: "bg-warning/15 text-warning border border-warning/40",
    descriptionEn:
      "Saturn transits the 12th house from your natal Moon. Focus turns toward financial adjustments, unforeseen expenditures, overseas matters, and mental restlessness.",
    descriptionHi:
      "शनि आपके जन्म चंद्रमा से 12वें भाव में गोचर करते हैं। इस चरण में व्यय में वृद्धि, अनिद्रा, विदेश यात्रा या दूरस्थ स्थानों से संबंध और अप्रत्याशित खर्चे सामने आते हैं।",
    keyChallengeEn: "Managing expenses, sleep hygiene, and emotional detachment from outcomes.",
    keyChallengeHi: "अनावश्यक खर्चों पर नियंत्रण, मानसिक शांति और धैर्य बनाए रखना।",
    upayEn:
      "Chant 'Om Sham Shanishcharaya Namah' 108 times on Saturdays; donate sesame oil or black blankets.",
    upayHi: "प्रतिदिन 'ॐ शं शनैश्चराय नमः' का जप करें; शनिवार को काले तिल या कंबल का दान करें।",
  },
  {
    id: "phase2",
    nameEn: "Phase 2: Peak (Janma Shani)",
    nameHi: "द्वितीय चरण: शिखर / जन्म शनि (लग्न/चन्द्र भाव)",
    duration: "~2.5 Years",
    transitHouse: "1st House (Over Natal Moon)",
    colorClass: "border-error/30 bg-error/10 text-text-primary",
    badgeClass: "bg-error/15 text-error border border-error/40",
    descriptionEn:
      "Saturn transits directly over your natal Moon. This is the most transformative phase, directly challenging self-identity, physical vitality, career responsibilities, and emotional stamina.",
    descriptionHi:
      "शनि का गोचर सीधे जन्म के चंद्रमा के ऊपर होता है। यह साढ़ेसाती का सबसे संवेदनशील चरण है, जो स्वास्थ्य, कार्यभार और मानसिक धैर्य की कड़ी परीक्षा लेता है।",
    keyChallengeEn:
      "Handling heavy responsibilities, avoiding hasty decisions, and maintaining physical health.",
    keyChallengeHi:
      "अत्यधिक कार्यभार में संतुलन, जल्दबाजी में बड़े निर्णयों से बचना और स्वास्थ्य का ध्यान।",
    upayEn:
      "Recite Hanuman Chalisa daily at twilight; light a mustard oil deepak near a Peepal tree on Saturdays.",
    upayHi:
      "संध्याकाल में नित्य श्री हनुमान चालीसा का पाठ करें; शनिवार को पीपल के नीचे सरसों के तेल का दीपक लगाएं।",
  },
  {
    id: "phase3",
    nameEn: "Phase 3: Setting (Avarohan)",
    nameHi: "तृतीय चरण: अवरोही (2रा भाव)",
    duration: "~2.5 Years",
    transitHouse: "2nd House from Natal Moon",
    colorClass: "border-accent/40 bg-accent/10 text-text-primary",
    badgeClass: "bg-accent/15 text-accent border border-accent/40",
    descriptionEn:
      "Saturn transits the 2nd house from your natal Moon. Pressure shifts to family harmony, accumulated wealth, speech, and stabilizing long-term foundations.",
    descriptionHi:
      "शनि चंद्रमा से द्वितीय (धन एवं कुटुंब) भाव में गोचर करते हैं। इस चरण में पारिवारिक जिम्मेदारियाँ, संचित धन और वाणी पर संयम अत्यंत महत्वपूर्ण होता है।",
    keyChallengeEn:
      "Refining speech, resolving family disputes patiently, and consolidating savings.",
    keyChallengeHi: "वाणी में मधुरता, पारिवारिक विवादों से दूरी और संचित धन की सुरक्षा।",
    upayEn: "Feed black cows or dogs; support elderly laborers or service staff with respect.",
    upayHi: "काली गाय या श्वान को रोटी खिलाएं; वृद्धजनों और सेवादारों का सम्मान व सहायता करें।",
  },
  {
    id: "dhaiya4",
    nameEn: "Kantaka Shani (4th Dhaiya)",
    nameHi: "कंटक शनि (चतुर्थ भाव ढैय्या)",
    duration: "~2.5 Years",
    transitHouse: "4th House from Natal Moon",
    colorClass: "border-info/30 bg-info/10 text-text-primary",
    badgeClass: "bg-info/15 text-info border border-info/40",
    descriptionEn:
      "When Saturn transits the 4th house from your natal Moon, it is termed Kantaka Shani. Affects domestic peace, mother's health, property, and vehicle matters.",
    descriptionHi:
      "जब शनि चंद्रमा से चतुर्थ भाव में गोचर करते हैं तो इसे कंटक शनि या लघु कल्याणी ढैय्या कहते हैं। यह गृह सुख, माता के स्वास्थ्य और संपत्ति मामलों को प्रभावित करता है।",
    keyChallengeEn: "Maintaining domestic tranquility and regular health check-ups for elders.",
    keyChallengeHi: "पारिवारिक शांति और संपत्ति के लेन-देन में सतर्कता।",
    upayEn:
      "Perform Shiva Abhishekam on Mondays; offer water to Peepal without touching on Saturdays.",
    upayHi: "सोमवार को भगवान शिव का जलाभिषेक करें; शनिवार को पीपल को जल अर्पित करें।",
  },
  {
    id: "dhaiya8",
    nameEn: "Ashtama Shani (8th Dhaiya)",
    nameHi: "अष्टम शनि (अष्टम भाव ढैय्या)",
    duration: "~2.5 Years",
    transitHouse: "8th House from Natal Moon",
    colorClass: "border-border-strong bg-surface-pressed text-text-primary",
    badgeClass: "bg-surface-raised text-text-secondary border border-border-strong",
    descriptionEn:
      "When Saturn transits the 8th house from your natal Moon, it creates Ashtama Shani. Demands caution against sudden changes, joint finances, and requires discipline.",
    descriptionHi:
      "जब शनि चंद्रमा से आठवें भाव में आते हैं, इसे अष्टम शनि कहते हैं। इसमें अचानक आने वाले बदलावों, स्वास्थ्य व वाहन चालन में विशेष सावधानी बरतनी चाहिए।",
    keyChallengeEn: "Prudence in investments, avoiding risky ventures, and stress management.",
    keyChallengeHi: "जोखिम भरे निवेश से बचना, संयमित जीवनशैली और नियमित ध्यान।",
    upayEn:
      "Recite Maha Mrityunjaya Mantra daily; light an iron lamp with mustard oil on Saturdays.",
    upayHi: "नित्य महामृत्युंजय मंत्र का जप करें; शनिवार को लोहे के पात्र में तेल का दीपक जलाएं।",
  },
];

export function SadeSatiPhases({ locale = "en" }: { locale?: "en" | "hi" }) {
  const [activeTab, setActiveTab] = useState<string>("phase1");
  const isHi = locale === "hi";

  const selectedPhase = PHASES.find((p) => p.id === activeTab) || PHASES[0];

  return (
    <div className="card-sacred p-6 sm:p-8 mt-6">
      <div className="text-center mb-6">
        <span className="text-eyebrow font-semibold uppercase tracking-widest text-intent-brand">
          {isHi ? "वैदिक गोचर कालक्रम" : "Vedic Transit Timeline"}
        </span>
        <h2 className="text-xl sm:text-2xl font-bold font-serif text-ish-dark mt-1">
          {isHi
            ? "साढ़ेसाती एवं ढैय्या के 5 प्रमुख चरण"
            : "The 5 Phases of Shani Sade Sati & Dhaiya"}
        </h2>
        <p className="text-xs text-ish-text-muted mt-1 max-w-md mx-auto">
          {isHi
            ? "शनि का गोचर आपके जन्म चंद्रमा के सापेक्ष जीवन के विभिन्न क्षेत्रों को जागृत करता है:"
            : "Saturn's transit relative to your natal Moon governs specific areas of discipline and growth:"}
        </p>
      </div>

      {/* Tabs */}
      <div className="flex overflow-x-auto gap-2 pb-2 mb-6 border-b border-ish-border no-scrollbar">
        {PHASES.map((phase) => (
          <button
            key={phase.id}
            type="button"
            onClick={() => setActiveTab(phase.id)}
            className={`whitespace-nowrap px-3.5 py-2 rounded-lg text-xs font-semibold transition ${
              activeTab === phase.id
                ? "bg-surface-brand-strong text-white shadow-xs"
                : "bg-surface-raised text-text-secondary hover:bg-surface-pressed"
            }`}
          >
            {isHi ? phase.nameHi.split(":")[0] : phase.nameEn.split(":")[0]}
          </button>
        ))}
      </div>

      {/* Active Phase Card */}
      <div className={`rounded-xl border p-5 sm:p-6 transition-all ${selectedPhase.colorClass}`}>
        <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
          <span
            className={`px-2.5 py-1 rounded-full text-xs font-bold ${selectedPhase.badgeClass}`}
          >
            {isHi ? selectedPhase.nameHi : selectedPhase.nameEn}
          </span>
          <span className="text-xs font-mono font-semibold opacity-75">
            {selectedPhase.duration} · {selectedPhase.transitHouse}
          </span>
        </div>

        <p className="text-sm leading-relaxed mb-4 font-sans">
          {isHi ? selectedPhase.descriptionHi : selectedPhase.descriptionEn}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4 pt-4 border-t border-black/10 text-xs">
          <div>
            <span className="font-bold block mb-1">
              {isHi ? "🎯 मुख्य सावधानी व परीक्षा:" : "🎯 Key Challenge:"}
            </span>
            <p className="opacity-90">
              {isHi ? selectedPhase.keyChallengeHi : selectedPhase.keyChallengeEn}
            </p>
          </div>
          <div>
            <span className="font-bold block mb-1">
              {isHi ? "📿 अनुशंसित वैदिक उपाय:" : "📿 Recommended Upay:"}
            </span>
            <p className="opacity-90">{isHi ? selectedPhase.upayHi : selectedPhase.upayEn}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
